export default (a, b) => {
  // lack of order prop means it's first
  if (!a.order && b.order) {
    return -1
  }
  if (a.order && !b.order) {
    return 1
  }
  // if order first
  if (a.order > b.order) {
    return 1
  }
  if (a.order < b.order) {
    return -1
  }
  // fall back to date
  if (a.created > b.created) {
    return -1
  }
  if (a.created < b.created) {
    return 1
  }
  return 0
}
